// src/components/DynamicReportInputs/DistributorSelector.js
import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import { dbGet } from "utils/DBFetchers"; // Asumo que usas tu utilidad estándar

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 250,
    width: "100%",
  },
}));

export default function DistributorSelector({ value, onChange, error = null, required = false }) {
  const classes = useStyles();
  const [distributors, setDistributors] = useState([]);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    let active = true;

    const fetchDistributors = async () => {
      try {
        const data = await dbGet("distributors"); 
        if (active) {
          const list = Array.isArray(data) ? data : data.data || [];
          setDistributors(list);
        }
      } catch (err) {
        if (active) {
          setFetchError("Error al cargar distribuidores");
        }
      }
    };

    fetchDistributors();

    return () => {
      active = false;
    };
  }, []);

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <FormControl 
      variant="outlined" 
      className={classes.formControl} 
      error={!!error || !!fetchError}
      required={required}
    >
      <InputLabel id="distributor-select-label">Distribuidor</InputLabel>
      <Select
        labelId="distributor-select-label"
        id="distributor-select"
        value={value}
        onChange={handleChange}
        label="Distribuidor"
      >
        <MenuItem value="">
          <em>Seleccione</em>
        </MenuItem>
        
        {distributors.map((dist) => (
          <MenuItem key={dist.id} value={dist.id}>
            {dist.name}
          </MenuItem>
        ))}
      </Select>
      
      {distributors.length === 0 && !fetchError && (
        <FormHelperText>Cargando opciones...</FormHelperText>
      )}
      {fetchError && <FormHelperText>{fetchError}</FormHelperText>}
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
